import React from "react";
import type {FunctionComponent} from "react";
import {isAppEnvLocalDev} from "../../../config/environment";



export const WhenEnvIsDevLocal: FunctionComponent = ({children}) => {
  if (!isAppEnvLocalDev) {
    return null;
  }
  return <>{children}</>;
}

